import * as React from "react";
import { forwardRef } from "react";
const SvgUploadCloud = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M8 16L12 12M12 12L16 16M12 12V21M20 17.6073C21.4937 16.8398 22.5 15.3266 22 13C21.5 10.6734 19.5 9.5 17.5 9.5C17.0929 6.83757 14.7908 4.5 12 4.5C9.02502 4.5 6.5 6.9 6.5 10C4.5 10 2 11.5 2 14.5C2 16.0503 2.8 17.1 4 17.6073", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgUploadCloud);
export { ForwardRef as ReactComponent };
